import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseToolsUrl + '/gitlab/api/v1/'

export const getGroups = (params) => {
  return axios.request({
    url: baseUrl + 'group/list/',
    params: params,
    method: 'get'
  })
}

export const getSonGroups = (params) => {
  return axios.request({
    url: baseUrl + 'son_group/list/',
    params: params,
    method: 'get'
  })
}

export const getAllUsers = (params) => {
  return axios.request({
    url: baseUrl + 'user/list/',
    params: params,
    method: 'get'
  })
}

export const getGroupUsers = (params) => {
  return axios.request({
    url: baseUrl + 'group_user/list/',
    params: params,
    method: 'get'
  })
}

export const getGroupProjects = (params) => {
  return axios.request({
    url: baseUrl + 'group_project/list/',
    params: params,
    method: 'get'
  })
}

export const getAllProjects = () => {
  return axios.request({
    url: baseUrl + 'project/list/all/',
    method: 'get'
  })
}

export const addGroupMember = (data) => {
  return axios.request({
    url: baseUrl + 'group_user/add/',
    data: data,
    method: 'post'
  })
}

export const deleteGroupMember = (data) => {
  return axios.request({
    url: baseUrl + 'group_user/delete/',
    data: data,
    method: 'delete'
  })
}

export const addProjectMember = (data) => {
  return axios.request({
    url: baseUrl + 'project_user/add/',
    data: data,
    method: 'post'
  })
}

export const deleteProjectMember = (data) => {
  return axios.request({
    url: baseUrl + 'project_user/delete/',
    data: data,
    method: 'delete'
  })
}

export const getProjectUsers = (params) => {
  return axios.request({
    url: baseUrl + 'project_user/list/',
    params: params,
    method: 'get'
  })
}

export const getAllNodes = () => {
  return axios.request({
    url: baseUrl + 'all_nodes_list/',
    method: 'get'
  })
}

export const getNodes = (params) => {
  return axios.request({
    url: baseUrl + 'node/',
    params: params,
    method: 'get'
  })
}

export const deleteNode = (id) => {
  return axios.request({
    url: baseUrl + 'node/' + id + '/',
    method: 'delete'
  })
}

export const detailNode = (id) => {
  return axios.request({
    url: baseUrl + 'node/' + id + '/',
    method: 'get'
  })
}

export const changeNode = (data, id) => {
  let url = baseUrl + 'node/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}
